import { DataReader, SerializationUtil } from ".";

import { CompiledGeometryContainer, DataLayoutType } from "../Geometry";

export class CompiledGeometryReader extends DataReader<CompiledGeometryContainer> {
    public read(data: Uint8Array): CompiledGeometryContainer {
        let util = new SerializationUtil().readFrom(data, true);
        let container = new CompiledGeometryContainer();

        container.reference = util.readString();
        container.textureReference = util.readString();

        let vertexCount = util.readUint32();
        let vertexLength = util.readUint32();

        let layouts: DataLayoutType[] = [];
        let layoutCount = util.readUint8();
        for (let i = 0; i < layoutCount; i++) {
            layouts.push({
                identifier: util.readString(),
                length: util.readUint8(),
                offset: util.readUint8()
            });
        }

        let geoData = util.readVaryingFloat32Array();

        container.geometry = {
            dataLayout: layouts,
            vertexCount: vertexCount,
            vertexLength: vertexLength,
            geometryData: geoData
        };

        return container;
    }

}